import React from 'react';
import { getProductsToExchange } from './utils';
import {
	useGetServicesRefundInfoQuery,
	PassengerSelectedGdsServicesFragment,
	PassengerFragment
} from '@websky/graphql';
import { Id } from '../types';

export interface UseRefundSummaryParams {
	orderId: Id;
	passengers: PassengerFragment[];
	selectedPassengerIds: string[];
	selectedSegmentIds: string[];
	allFlightToExchange: boolean;
}

export function useRefundSummary({
	orderId,
	allFlightToExchange,
	selectedSegmentIds,
	selectedPassengerIds,
	passengers
}: UseRefundSummaryParams) {
	const services: PassengerSelectedGdsServicesFragment[] = [];
	selectedPassengerIds.forEach(passengerId => {
		const passenger = passengers.find(p => p.id === passengerId);

		if (passenger?.services?.gdsServices?.services) {
			services.push(...passenger?.services?.gdsServices?.services);
		}

		if (passenger?.services?.seats) {
			passenger.services.seats.forEach(seat => {
				if (!seat.product) {
					return;
				}

				services.push({
					segmentIds: [seat.segment.id],
					products: [seat.product]
				} as PassengerSelectedGdsServicesFragment);
			});
		}
	});

	const selectedProductIds = React.useMemo(() => {
		return getProductsToExchange(services, allFlightToExchange ? [] : selectedSegmentIds);
	}, [services, selectedSegmentIds, allFlightToExchange]);

	const { data, loading } = useGetServicesRefundInfoQuery({
		variables: {
			params: {
				orderId,
				productIds: selectedProductIds
			}
		},
		skip: !selectedProductIds.length
	});

	return {
		gdsServicesRefund: data,
		loading,
		hasServicesToRefund: !!data?.GetGdsServicesRefundInfo?.gdsServicesRefundInfo?.length,
		hasSelectedProducts: !selectedProductIds.length
	};
}
